import { Popover as PopoverPrimitive } from '@base-ui/react/popover';

export type PopoverTriggerProps = PopoverPrimitive.Trigger.Props;

const PopoverTrigger = ({ ...props }: PopoverTriggerProps) => {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
};

export default PopoverTrigger;
